import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-4" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex-1" }

import { ref, watch } from "vue";
import type { Ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RangeFilter',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["change"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const model = _useModel<RangeFilterValue | null>(__props, "modelValue")
const emit = __emit;

const min: Ref<string | null> = ref(null);
const max: Ref<string | null> = ref(null);

function emptyStringToNull(value: string | null) {
  if (value === null || value === '') {
    return null;
  }

  return value;
}

function updateValues() {
  let value;
  const minVal = emptyStringToNull(min.value)
  const maxVal = emptyStringToNull(max.value)
  if (minVal === null && maxVal === null) {
    value = null;
  } else {
    value = {
      min: minVal,
      max: maxVal,
    }
  }
  model.value = value;
  emit("change", value);
};

watch(model, (value) => {
  if (value === null) {
    min.value = null;
    max.value = null;
  } else {
    min.value = value.min;
    max.value = value.max;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((min).value = $event)),
        class: "block pr-10 w-full rounded border transition border-neutral-200 hover:border-teal focus:ring-teal focus:border-teal"
      }, null, 512), [
        [
          _vModelText,
          min.value,
          void 0,
          { number: true }
        ]
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-xs text-neutral-600" }, "Fra", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((max).value = $event)),
        class: "block pr-10 w-full rounded border transition border-neutral-200 hover:border-teal focus:ring-teal focus:border-teal"
      }, null, 512), [
        [
          _vModelText,
          max.value,
          void 0,
          { number: true }
        ]
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs text-neutral-600" }, "Til", -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "block py-2 px-3 w-full bg-white rounded border transition border-neutral-200 text-neutral-700 hover:border-teal",
        onClick: _withModifiers(updateValues, ["prevent"])
      }, " Søk ")
    ])
  ]))
}
}

})